// components/Rooms.js
import React, { useState } from 'react';
import './Rooms.css';
import Modal from './Modal';
import imgLivingRoom4 from '../img/Living room (4).png';
import imgBedroom1_2 from '../img/Bedroom 1 (2).png';

const roomData = [
  {
    name: 'Living Area',
    description: 'Modern parlour featuring a comfy lounge chair, flat-screen TV with DSTV, chic center table, cozy sofa, wine shelf, and warm lighting.',
    image: imgLivingRoom4,
    details: 'The living area is designed for relaxation and entertainment. It features a 42" smart TV with DSTV and Netflix, a premium sound system, and comfortable seating. The perfect place to unwind after a day of exploring Abuja.'
  },
  {
    name: 'Bedroom',
    description: 'A serene bedroom with a 32" smart TV and fresh linens await you for a cozy night\'s rest.',
    image: imgBedroom1_2,
    details: 'The bedroom is your private sanctuary. It features a comfortable queen-sized bed with fresh linens, a 32" smart TV, and ample storage space. The room is designed to be a peaceful and relaxing space.'
  },
  // Add more room objects as needed
];

function RoomCard({ room, onOpenModal }) {
  return (
    <div className="room-card">
      <img src={room.image} alt={room.name} />
      <h3>{room.name}</h3>
      <p>{room.description}</p>
      <button className="btn-tertiary" onClick={() => onOpenModal(room)}>View Details</button>
    </div>
  );
}

function Rooms() {
  const [showModal, setShowModal] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  const handleOpenModal = (room) => {
    setSelectedRoom(room);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRoom(null);
  };

  return (
    <section id="rooms" className="rooms-section">
      <h2 className="reveal">Where you’ll sleep</h2>
      <div className="room-grid reveal">
        {roomData.map((room, index) => (
          <RoomCard key={index} room={room} onOpenModal={handleOpenModal} />
        ))}
      </div>
      <Modal show={showModal} onClose={handleCloseModal}>
        {selectedRoom && (
          <>
            <h2>{selectedRoom.name}</h2>
            <img src={selectedRoom.image} alt={selectedRoom.name} style={{ width: '100%', borderRadius: '10px' }} />
            <p>{selectedRoom.details}</p>
          </>
        )}
      </Modal>
    </section>
  );
}

export default Rooms;
